import { createApp } from 'vue/dist/vue.esm-bundler';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default {
    mounted() {
        const app = createApp({
            mounted() {
                document.body.classList.add('initialized');

                // @see https://michalsnik.github.io/aos/
                AOS.init();
            },
        });

        // Register components
        [ Popover, PopoverButton, PopoverPanel ].map((component) => app.component(component.name, component));

        // @note - We mount on app-header to prevent GDPR preferences link to break
        app.mount('.app-header');
    },
};
